import React from 'react';

import { useAPIAuthenticatedService } from '../../helpers/APICallsAuthenticated';
import { CacheKeys } from '../../helpers/DataStructures';
import AdminGroupReferralsPage from './AdminGroupReferralsPage';

const AdminGroupTwoReferralsPage: React.FC = () => {
  const apiServiceInstance = useAPIAuthenticatedService();

  return (
    <AdminGroupReferralsPage
      emptyMessage="No referrals found for group 2."
      errorMessage="Unable to load group 2 referrals."
      loadReferrals={apiServiceInstance.getAdminGroupTwoReferrals}
      queryKey={CacheKeys.ADMIN_REFERRALS_GROUP_TWO}
      title="All Referrals Group 2"
    />
  );
};

export default AdminGroupTwoReferralsPage;
